{
  "nav": {
    "home": "Home",
    "mobileHomes": "Mobiele Woningen",
    "products": "Andere Producten",
    "about": "Over Ons",
    "contact": "Contact",
    "blog": "Blog",
    "enquire": "Informeer nu",
    "openMenu": "Menu openen",
    "closeMenu": "Menu sluiten"
  },
  "common": {
    "readMore": "Lees meer",
    "submit": "Verzenden",
    "cancel": "Annuleren",
    "loading": "Laden...",
    "error": "Er is een fout opgetreden",
    "success": "Succes",
    "search": "Zoeken",
    "title": "Vertaling Voorbeeld",
    "examples": "Vertaling Voorbeelden",
    "key": "Sleutel",
    "translation": "Vertaling",
    "currentLanguage": "Huidige Taal"
  },
  "contact": {
    "loading": "Contactinformatie laden...",
    "title": "Contact",
    "intro": "Heeft u een project in gedachten? Stuur ons een aanvraag en we nemen contact met u op.",
    "enquireNow": "Offerte Aanvragen",
    "generalEnquiries": "Algemene Vragen",
    "salesEnquiries": "Verkoopvragen",
    "followUs": "Volg Ons",
    "ourOffice": "Ons Kantoor",
    "viewMap": "Kaart Bekijken",
    "ourFactory": "Onze Fabriek",
    "address": {
      "full": "Temes u. 18, 3528 Miskolc, HONGARIJE",
      "label": "Adres"
    },
    "phone": {
      "number": "(+381) 69 220 7072",
      "label": "Telefoon"
    },
    "officeDescription": "Met uitgebreide ervaring in gastvrijheid en klantenservice is ons team toegewijd aan het bieden van een naadloze ervaring van begin tot eind.",
    "factoryDescription": "Gelegen in het contactcentrum in Miskolc, is onze fabriek uitgerust met de nieuwste productietechnologie om hoogwaardige modulaire huizen en structuren te leveren.",
    "name": "Naam",
    "email": "E-mail",
    "message": "Bericht",
    "formPhone": "Telefoon",
    "formAddress": "Adres",
    "send": "Bericht Verzenden"
  },
  "enquiry": {
    "formTitle": "Aanvraagformulier",
    "generalEnquiry": "Algemene Aanvraag",
    "specificProduct": "Als u een specifieke productvraag wilt indienen, ga dan naar de productpagina.",
    "privacyConsent": "Ik ga akkoord met de verwerking van mijn persoonsgegevens in overeenstemming met het Privacybeleid *"
  },
  "home": {
    "featuredHomes": {
      "natura": {
        "name": "Natura",
        "description": "Milieuvriendelijk, Modern Comfort"
      },
      "sensa": {
        "name": "Sensa",
        "description": "Ruime Uitzichten, Open Wonen"
      }
    },
    "hero": {
      "title": "Premium Wonen, Waar U Ook Gaat",
      "subtitle": "Ontdek ons assortiment premium mobiele woningen en producten"
    },
    "intro": "Welkom bij MZM Homes, waar innovatief design duurzame constructie ontmoet.",
    "intro2": "We benutten de kracht van offsite fabricage om op maat gemaakte modulaire woningen en andere projecten te leveren.",
    "mobileHomes": {
      "title": "Mobiele Woningen",
      "description": "Verken onze collectie vakkundig vervaardigde modulaire woningen, ontworpen voor comfort, stijl en flexibiliteit. Gebouwd om bij elke levensstijl te passen, bieden deze woningen luxe wonen met de vrijheid om te gaan waar het leven u brengt."
    },
    "otherProducts": {
      "title": "Andere Producten",
      "description": "Ontdek ons assortiment aanpasbare structuren, waaronder garages, carports, containers en terrassen, ontworpen om elk huis aan te vullen. Elk product combineert duurzaamheid en stijl, en creëert functionele ruimtes."
    },
    "featuredProducts": {
      "garages": {
        "name": "Garages",
        "description": "Duurzame, stijlvolle oplossingen om uw voertuigen te beschermen en uw eigendom te verfraaien."
      },
      "carports": {
        "name": "Carports",
        "description": "Openlucht voertuigbeschermingsoplossingen die duurzaamheid combineren met toegankelijkheid."
      },
      "containers": {
        "name": "Containers",
        "description": "Verken onze veelzijdige containeroplossingen, ontworpen voor duurzaamheid en eindeloze mogelijkheden."
      },
      "outdoorKitchens": {
        "name": "Buitenkeukens",
        "description": "Transformeer uw buitenruimte met onze stijlvolle en functionele buitenkeukenoplossingen."
      },
      "garbageBins": {
        "name": "Afvalbakken",
        "description": "Praktische en stijlvolle oplossingen voor afvalbeheer."
      }
    },
    "testimonials": {
      "title": "Klantverhalen",
      "description": "Onze toewijding aan kwaliteit en persoonlijke service heeft een blijvende indruk achtergelaten. Ontdek hoe onze modulaire woningen en structuren hun leefruimtes hebben getransformeerd en hun levensstijl hebben verbeterd."
    },
    "loading": "Laden",
    "enquireNow": "Offerte Aanvragen"
  },
  "products": {
    "loading": "Producten laden...",
    "title": "Andere Producten",
    "description": "Ontdek ons assortiment aanpasbare structuren, waaronder garages, carports, containers en terrassen, ontworpen om elk huis aan te vullen. Elk product combineert duurzaamheid en stijl, en creëert functionele ruimtes.",
    "viewAll": "Bekijk Alles",
    "noProducts": "Momenteel geen producten beschikbaar. Kom later terug.",
    "categoriesTitle": "Productcategorieën",
    "categoriesObject": {
      "title": "Productcategorieën",
      "list": {
        "garagesCarports": {
          "name": "Garages & Carports",
          "description": "Duurzame, stijlvolle oplossingen om uw voertuigen te beschermen en uw eigendom te verfraaien. Ontworpen voor zowel functionaliteit als esthetische aantrekkingskracht, bieden deze structuren de perfecte mix van veiligheid en elegantie."
        },
        "containers": {
          "name": "Containers",
          "description": "Verken onze veelzijdige containeroplossingen, ontworpen voor duurzaamheid en eindeloze mogelijkheden. Of het nu voor opslag, transport of aangepaste projecten is, onze containers bieden betrouwbare, flexibele opties om aan uw unieke behoeften te voldoen."
        },
        "outdoorKitchens": {
          "name": "Buitenkeukens",
          "description": "Transformeer uw buitenruimte met onze stijlvolle en functionele buitenkeukenoplossingen. Perfect om gasten te entertainen of te genieten van gezinsmaaltijden in de frisse lucht."
        },
        "garbageBins": {
          "name": "Afvalbakken",
          "description": "Praktische en stijlvolle oplossingen voor afvalbeheer. Onze afvalbakbehuizingen houden uw buitenruimte netjes en vullen de esthetiek van uw huis aan."
        }
      }
    },
    "details": "Productdetails",
    "specifications": "Specificaties",
    "categories": {
      "garages": {
        "name": "Garages",
        "description": "Duurzame, stijlvolle oplossingen om uw voertuigen te beschermen en uw eigendom te verfraaien. Ontworpen voor zowel functionaliteit als esthetische aantrekkingskracht, bieden deze structuren de perfecte mix van veiligheid en elegantie."
      },
      "carports": {
        "name": "Carports",
        "description": "Openlucht voertuigbeschermingsoplossingen die duurzaamheid combineren met toegankelijkheid. Onze carports bieden betrouwbare beschutting voor uw voertuigen met behoud van een open ontwerp dat naadloos integreert met uw eigendom."
      },
      "containers": {
        "name": "Containers",
        "description": "Verken onze veelzijdige containeroplossingen, ontworpen voor duurzaamheid en eindeloze mogelijkheden. Of het nu voor opslag, transport of aangepaste projecten is, onze containers bieden betrouwbare, flexibele opties om aan uw unieke behoeften te voldoen."
      },
      "outdoorKitchens": {
        "name": "Buitenkeukens",
        "description": "Transformeer uw buitenruimte met onze stijlvolle en functionele buitenkeukenoplossingen. Perfect om gasten te entertainen of te genieten van gezinsmaaltijden in de frisse lucht."
      },
      "garbageBins": {
        "name": "Afvalbakken",
        "description": "Praktische en stijlvolle oplossingen voor afvalbeheer. Onze afvalbakbehuizingen houden uw buitenruimte netjes en vullen de esthetiek van uw huis aan."
      }
    },
    "categoryDetails": {
      "garagesCarports": {
        "name": "Garages & Carports",
        "description": "Duurzame, stijlvolle oplossingen om uw voertuigen te beschermen en uw eigendom te verfraaien. Ontworpen voor zowel functionaliteit als esthetische aantrekkingskracht, bieden deze structuren de perfecte mix van veiligheid en elegantie."
      },
      "containers": {
        "name": "Containers",
        "description": "Verken onze veelzijdige containeroplossingen, ontworpen voor duurzaamheid en eindeloze mogelijkheden. Of het nu voor opslag, transport of aangepaste projecten is, onze containers bieden betrouwbare, flexibele opties om aan uw unieke behoeften te voldoen."
      },
      "outdoorKitchens": {
        "name": "Buitenkeukens",
        "description": "Transformeer uw buitenruimte met onze stijlvolle en functionele buitenkeukenoplossingen. Perfect om gasten te entertainen of te genieten van gezinsmaaltijden in de frisse lucht."
      },
      "garbageBins": {
        "name": "Afvalbakken",
        "description": "Praktische en stijlvolle oplossingen voor afvalbeheer. Onze afvalbakbehuizingen houden uw buitenruimte netjes en vullen de esthetiek van uw huis aan."
      }
    },
    "garages": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Compacte en functionele garage voor één voertuig"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Ruime garageoplossing voor meerdere voertuigen"
      },
      "garageWithCarport": {
        "name": "Garage met carport",
        "description": "Gecombineerde oplossing met afgesloten garage en aangebouwde carport"
      }
    },
    "carports": {
      "carport6x3": {
        "name": "Carport 6x3",
        "description": "Openlucht voertuigbescherming met duurzame constructie"
      },
      "carport6x6": {
        "name": "Carport 6x6",
        "description": "Ruime openlucht schuilplaats voor meerdere voertuigen"
      }
    },
    "containers": {
      "basic": {
        "name": "BASIC Container",
        "description": "Eenvoudige, duurzame opslagoplossing voor diverse behoeften"
      },
      "premium": {
        "name": "PREMIUM Container",
        "description": "Verbeterde container met extra functies en superieure kwaliteit"
      }
    },
    "outdoorKitchens": {
      "basic": {
        "name": "BASIC Buitenkeuken",
        "description": "Eenvoudige en functionele buitenkeukenoplossing"
      },
      "premium": {
        "name": "PREMIUM Buitenkeuken",
        "description": "Luxe buitenkeuken met premium functies"
      }
    },
    "garbageBins": {
      "basic": {
        "name": "BASIC Afvalbakopslag",
        "description": "Eenvoudige en functionele afvalbakoplossing"
      },
      "premium": {
        "name": "PREMIUM Afvalbakopslag",
        "description": "Verbeterde afvalbakoplossing met premium functies"
      }
    },
    "items": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Compacte en functionele garage voor één voertuig"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Ruime garageoplossing voor meerdere voertuigen"
      },
      "garageWithCarport": {
        "name": "Garage met carport",
        "description": "Gecombineerde oplossing met afgesloten garage en aangebouwde carport"
      },
      "basicContainer": {
        "name": "BASIC Container",
        "description": "Eenvoudige, duurzame opslagoplossing voor diverse behoeften"
      },
      "premiumContainer": {
        "name": "PREMIUM Container",
        "description": "Verbeterde container met extra functies en superieure kwaliteit"
      },
      "basicKitchen": {
        "name": "BASIC Buitenkeuken",
        "description": "Eenvoudige en functionele buitenkeukenoplossing"
      },
      "premiumKitchen": {
        "name": "PREMIUM Buitenkeuken",
        "description": "Luxe buitenkeuken met premium functies"
      },
      "basicBin": {
        "name": "BASIC Afvalbakopslag",
        "description": "Eenvoudige en functionele afvalbakoplossing"
      },
      "premiumBin": {
        "name": "PREMIUM Afvalbakopslag",
        "description": "Verbeterde afvalbakoplossing met premium functies"
      }
    }
  },
  "about": {
    "loading": "Over Ons Pagina Laden...",
    "title": "Over Ons",
    "whoWeAre": "Wie We Zijn",
    "jumpTo": "Spring Naar",
    "meetTheTeam": "Ontmoet Het Team",
    "team": "Ons Team",
    "history": "Onze Geschiedenis",
    "mission": "Onze Missie",
    "part1": {
      "title": "MZM Homes is opgericht in 2024 door mensen die design, innovatie en duurzaamheid waarderen.",
      "description": "Als een van de toonaangevende experts in offsite constructie in Slovenië, besteden we meer tijd aan het bedenken hoe we beter, slimmer en sneller kunnen bouwen."
    },
    "part2": {
      "title": "Onze benadering maakt gebruik van de nieuwste productietechnologie, wat precisie, duurzaamheid en een aanzienlijk verminderde ecologische voetafdruk garandeert.",
      "description": "We promoten ook lokale materialen en leveranciers om uitzonderlijke oplossingen te leveren die duurzaamheid vooropstellen."
    },
    "part3": {
      "title": "Elk MZM Homes project is het resultaat van een unieke en bewezen benadering, gedemonstreerd in meer dan 100 voltooide woningen en andere structuren",
      "description": "Onze turn-key service en transparante prijsmodel zorgen voor een soepele overgang van tekentafel naar drempel, waardoor de reis net zo naadloos is als transformatief."
    }
  },
  "blog": {
    "latestPosts": "Laatste Berichten",
    "readMore": "Lees Meer",
    "postedOn": "Geplaatst Op"
  },
  "footer": {
    "salesEnquiries": "Verkoopvragen",
    "generalEnquiries": "Algemene vragen",
    "followUs": "Volg ons",
    "office": "MZM Kantoor",
    "factory": "MZM Fabriek",
    "pages": "Pagina's",
    "products": "Producten",
    "homePage": "Startpagina",
    "garages": "Garages",
    "carports": "Carports",
    "containers": "Containers",
    "kitchens": "Keukens",
    "garbageBins": "Afvalbakken",
    "rights": "Alle rechten voorbehouden",
    "copyright": "© {year} MZM Homes. Alle rechten voorbehouden.",
    "sitemap": "Sitemap",
    "privacy": "Privacybeleid",
    "terms": "Servicevoorwaarden",
    "cookies": "Cookiebeleid",
    "social": {
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "facebook": "Facebook"
    }
  },
  "homes": {
    "loading": "Woningmodellen Laden...",
    "gallery": {
      "loading": "Afbeeldingen Laden..."
    },
    "title": "Mobiele Woningen",
    "description": "Onze exclusieve collectie van vier vakkundig ontworpen woningmodellen, elk met een unieke mix van stijl, functionaliteit en vakmanschap. Van milieuvriendelijke innovaties tot ruime, luxueuze leefruimtes, onze woningen zijn afgestemd op diverse smaken en levensstijlen.",
    "error": {
      "title": "Oeps! Er is iets misgegaan",
      "message": "We konden de woningmodellen die u zoekt niet vinden.",
      "backButton": "Terug Naar Startpagina"
    },
    "naturaLine": {
      "title": "Natura Line",
      "description": "Introductie van de Natura lijn—waar duurzaamheid modern luxe ontmoet. Ontworpen met milieubewuste materialen en energiezuinige kenmerken, bieden deze woningen een perfecte balans van stijl, comfort en milieubewustzijn."
    },
    "sensaLine": {
      "title": "Sensa Line",
      "description": "Introductie van de Sensa lijn—verhoog uw woonervaring met ruime, open ontwerpen en adembenemende uitzichten. Deze woningen combineren hedendaagse elegantie met functionaliteit, en creëren de perfecte setting voor modern wonen."
    },
    "noResults": "Geen Woningmodellen Gevonden. Kom Later Terug.",
    "specifications": {
      "ceilingHeight": "Plafondhoogte",
      "windows": "Ramen",
      "terrace": "Terras",
      "wallRoofInsulation": "Muur & Dak Isolatie",
      "floorInsulation": "Vloer Isolatie",
      "energyRating": "Energieklasse"
    },
    "models": {
      "naturaMini": {
        "name": "Natura Mini",
        "description": "Milieuvriendelijk ontwerp met modern comfort en energiezuinigheid.",
        "longDescription": "De Natura Mini is ons vlaggenschip milieuvriendelijke woning, ontworpen met duurzaamheid in gedachten zonder in te boeten aan comfort of stijl. Met energiezuinige systemen, duurzame materialen en slimme huistechnologie, vertegenwoordigt dit model de toekomst van verantwoord wonen. Het open vloerplan creëert een ruimtelijk gevoel en maximaliseert het gebruik van natuurlijk licht."
      },
      "naturaMaxi": {
        "name": "Natura Maxi",
        "description": "Uitgebreide milieuvriendelijke woning met extra ruimte voor gezinnen.",
        "longDescription": "De Natura Maxi is onze grotere milieuvriendelijke woning, die extra ruimte biedt voor gezinnen met behoud van dezelfde toewijding aan duurzaamheid en kwaliteit. Met meer slaapkamers en leefruimte is dit model perfect voor degenen die extra ruimte nodig hebben zonder hun milieubewuste waarden op te geven."
      },
      "sensaMini": {
        "name": "Sensa Mini",
        "description": "Ruim ontwerp met grote ramen voor prachtige uitzichten.",
        "longDescription": "De Sensa Mini is ontworpen om uw verbinding met de omringende omgeving te maximaliseren door zijn uitgestrekte ramen en open concept leefruimtes. Perfect voor schilderachtige locaties, deze woning haalt de natuur naar binnen en biedt tegelijkertijd alle gemakken van modern wonen. Luxe afwerkingen en doordachte ontwerpelementen creëren een verfijnde maar comfortabele sfeer."
      },
      "sensaMaxi": {
        "name": "Sensa Maxi",
        "description": "Onze grootste panoramische woning met premium kenmerken en ruimte.",
        "longDescription": "De Sensa Maxi is ons ruimste model, met uitgestrekte leefruimtes en premium kenmerken. Met zijn grote ramen en open ontwerp creëert deze woning een naadloze verbinding met de buitenwereld en biedt tegelijkertijd alle luxe en comfort die u zich kunt wensen. Perfect voor degenen die een statement willen maken."
      }
    },
    "features": {
      "energyEfficient": "Energiezuinig Ontwerp",
      "sustainableMaterials": "Duurzame Materialen",
      "smartHome": "Slimme Huistechnologie",
      "openFloorPlan": "Open Vloerplan",
      "familySized": "Gezinsvriendelijke Indeling",
      "additionalStorage": "Extra Opslag",
      "floorToCeiling": "Vloer-tot-Plafond Ramen",
      "openConcept": "Open Concept Wonen",
      "luxuryFinishes": "Luxe Afwerkingen",
      "indoorOutdoor": "Binnen-Buiten Flow",
      "premiumFinishes": "Premium Afwerkingen",
      "spaciousMaster": "Ruime Hoofdslaapkamer",
      "multipleLiving": "Meerdere Leefruimtes",
      "homeOffice": "Thuiskantoor",
      "designerKitchen": "Designkeuken",
      "optionalDeck": "Optionele Dekaanbouw",
      "ledLighting": "LED-verlichting Door Het Hele Huis",
      "waterSaving": "Waterbesparende Armaturen",
      "insulationEnergy": {
        "insulation": {
          "highQuality": "Hoogwaardige Isolatie"
        }
      }
    },
    "includedFeatures": {
      "title": "Wat Is Inbegrepen?",
      "headers": {
        "centralSpace": "Centrale Ruimte",
        "bathroomBedrooms": "Badkamer & Slaapkamers",
        "outside": "Buiten"
      },
      "centralSpace": {
        "kitchen": "Keuken Met Inductiekookplaat",
        "refrigerator": "Koelkast",
        "sofa": "Uitschuifbare Bank",
        "tv": "LCD TV",
        "table": "Tafel",
        "chairs": "4 Stoelen"
      },
      "bathroomBedrooms": {
        "waterHeater": "Boiler",
        "bathroom": "Complete Badkamerunit",
        "toilet": "Toilet",
        "shower": "Douchecabine",
        "bedBase": "Latoflex Bedbodem",
        "mattress": "Matras",
        "wardrobe": "Kledingkast En Planken"
      },
      "outside": {
        "windows": "Panoramische Ramen Voor Prachtige Uitzichten",
        "heatingCable": "Verwarmingskabel Voor Buitenwateraansluiting",
        "protection": "Bescherming Voor Installaties",
        "terrace": "Terras (3x8m) Gemaakt Van Gegalvaniseerde Profielen En Bedekt Met Sandwichpanelen",
        "wallRoof": "Muur & Dak: 10 cm (W/mK = 0.22)",
        "decorativePanels": "Decoratieve Houten Panelen Gemaakt Van Gegalvaniseerd Staalplaat"
      }
    },
    "details": {
      "bedrooms": "Slaapkamers",
      "kitchen": "Keuken",
      "bathrooms": "Badkamers",
      "area": "Oppervlakte",
      "terrace": "Terras",
      "moreSpecifications": "Meer Specificaties",
      "enquireAbout": "Informeer Over Deze Woning",
      "insulationEnergy": "Isolatie & Energie-efficiëntie",
      "insulation": "Isolatie",
      "energyFeatures": "Energiekenmerken",
      "premiumFeatures": "Premium Kenmerken",
      "availableAsOption": "Beschikbaar als optie",
      "floorPlans": "Plattegrond",
      "floorPlansDescription": "Verken onze doordacht ontworpen plattegronden, afgestemd op verschillende levensstijlen. Elke indeling maximaliseert ruimte, comfort en functionaliteit, en biedt de perfecte basis voor uw droomhuis.",
      "otherModels": "Andere Woningmodellen",
      "otherModelsDescription": "Verken onze collectie vakkundig vervaardigde modulaire woningen, ontworpen voor comfort, stijl en flexibiliteit. Gebouwd om bij elke levensstijl te passen, bieden deze woningen luxe wonen met de vrijheid om te gaan waar het leven u brengt.",
      "garagesDescription": "Veilige Opslag, Strak Ontwerp",
      "containersDescription": "Flexibele, Duurzame Oplossingen",
      "homeGardenDescription": "Elegant Wonen, Buitenplezier"
    },
    "insulationEnergy": {
      "insulation": {
        "wallRoof": "Muur & Dak: 10cm (W/mK = 0.22)",
        "floor": "Vloer: 12cm Isolatie",
        "windows": "Ramen: Ug = 1.1 W/m²K",
        "doubleGlazed": "Dubbel Glas Ramen",
        "thermalBreak": "Thermisch Onderbrekingssysteem",
        "highQuality": "Hoogwaardige Isolatie"
      },
      "energyFeatures": {
        "solarReady": "Klaar Voor Zonnepanelen",
        "ledLighting": "LED-verlichting Door Het Hele Huis",
        "efficientAppliances": "Energiezuinige Apparaten"
      }
    },
    "premiumFeatures": {
      "panoramicWindows": "Panoramische Ramen Voor Prachtige Uitzichten",
      "flexibility": "Flexibiliteit En Mobiliteit",
      "qualityMaterials": "Hoogwaardige Materialen",
      "energyEfficiency": "Energie-efficiëntie",
      "aestheticAppeal": "Esthetische Aantrekkingskracht",
      "customization": "Aanpassing",
      "fastMoveIn": "Snelle Intrek",
      "idealRental": "Ideaal Voor Verhuur",
      "lowMaintenance": "Lage Onderhoudskosten",
      "privacy": "Privacy En Rust",
      "compactDesign": "Compact En Ruimtelijk Ontwerp"
    },
    "genericModel": {
      "name": "Woningmodel",
      "description": "Modern Modulair Woningontwerp.",
      "longDescription": "Dit model biedt de perfecte balans tussen comfort, stijl en functionaliteit. Ontworpen met modern wonen in gedachten, het beschikt over open ruimtes, kwaliteitsmaterialen en energiezuinige oplossingen.",
      "features": {
        "modernDesign": "Modern Ontwerp",
        "qualityMaterials": "Kwaliteitsmaterialen",
        "energyEfficiency": "Energie-efficiëntie",
        "customizableOptions": "Aanpasbare Opties"
      }
    }
  },
  "breadcrumb": {
    "home": "Startpagina",
    "mobileHomes": "Mobiele Woningen",
    "products": "Andere Producten",
    "about": "Over Ons",
    "contact": "Contact",
    "blog": "Blog",
    "garages": "Garages",
    "containers": "Containers",
    "homeGarden": "Huis & Tuin"
  },
  "productDetails": {
    "common": {
      "otherProducts": "Andere Producten",
      "otherProductsDescription": "Ontdek ons assortiment aanpasbare structuren, waaronder garages, carports, containers en terrassen, ontworpen om elk huis aan te vullen. Elk product combineert duurzaamheid en stijl, en creëert functionele ruimtes."
    },
    "garages": {
      "loading": "Garage Details Laden...",
      "error": {
        "title": "Oeps! Er Is Iets Misgegaan",
        "message": "We Konden De Garage Die U Zoekt Niet Vinden.",
        "backButton": "Terug Naar Garages"
      },
      "dimensions": "Afmetingen:",
      "area": "Oppervlakte:",
      "height": "Hoogte:",
      "doorWidth": "Deurbreedte:",
      "doorHeight": "Deurhoogte:",
      "moreSpecifications": "Meer Specificaties",
      "materials": "Materialen",
      "qualityMaterials": "Kwaliteitsmaterialen",
      "additionalFeatures": "Extra Kenmerken",
      "features": "Kenmerken",
      "customizationOptions": "Aanpassingsopties",
      "otherModels": "Andere Garage Modellen",
      "otherModelsDescription": "Verken onze selectie garageoplossingen ontworpen voor duurzaamheid, functionaliteit en stijl. Elk model biedt veilige opslag voor uw voertuigen en apparatuur.",
      "enquireButton": "Offerte Aanvragen",
      "enquireAbout": "Informeer Over Deze Garage",
      "openGallery": "Galerij Openen",
      "price": "Prijs:"
    },
    "containers": {
      "loading": "Container Details Laden...",
      "error": {
        "title": "Oeps! Er Is Iets Misgegaan",
        "message": "We Konden De Container Die U Zoekt Niet Vinden.",
        "backButton": "Terug Naar Containers"
      },
      "dimensions": "Afmetingen:",
      "area": "Oppervlakte:",
      "height": "Hoogte:",
      "doorWidth": "Deurbreedte:",
      "doorHeight": "Deurhoogte:",
      "moreSpecifications": "Meer Specificaties",
      "materials": "Materialen",
      "qualityMaterials": "Kwaliteitsmaterialen",
      "additionalFeatures": "Extra Kenmerken",
      "features": "Kenmerken",
      "customizationOptions": "Aanpassingsopties",
      "otherModels": "Andere Container Modellen",
      "otherModelsDescription": "Verken onze selectie containeroplossingen ontworpen voor veelzijdigheid, duurzaamheid en functionaliteit. Elk model biedt flexibele ruimte voor diverse toepassingen.",
      "enquireButton": "Offerte Aanvragen",
      "enquireAbout": "Informeer Over Deze Container",
      "openGallery": "Galerij Openen",
      "price": "Prijs:"
    },
    "outdoorKitchens": {
      "loading": "Buitenkeuken Details Laden...",
      "error": {
        "title": "Oeps! Er Is Iets Misgegaan",
        "message": "We Konden De Buitenkeuken Die U Zoekt Niet Vinden.",
        "backButton": "Terug Naar Buitenkeukens"
      },
      "dimensions": "Afmetingen:",
      "area": "Oppervlakte:",
      "height": "Hoogte:",
      "moreSpecifications": "Meer Specificaties",
      "materials": "Materialen",
      "qualityMaterials": "Kwaliteitsmaterialen",
      "additionalFeatures": "Extra Kenmerken",
      "features": "Kenmerken",
      "customizationOptions": "Aanpassingsopties",
      "otherModels": "Andere Buitenkeuken Modellen",
      "otherModelsDescription": "Verken onze selectie buitenkeukenoplossingen ontworpen voor stijl, functionaliteit en duurzaamheid. Elk model biedt een perfecte ruimte voor koken en entertainen buitenshuis.",
      "enquireButton": "Offerte Aanvragen",
      "enquireAbout": "Informeer Over Deze Buitenkeuken",
      "openGallery": "Galerij Openen",
      "price": "Prijs:"
    },
    "garbageBins": {
      "loading": "Afvalbak Details Laden...",
      "error": {
        "title": "Oeps! Er Is Iets Misgegaan",
        "message": "We Konden De Afvalbak Die U Zoekt Niet Vinden.",
        "backButton": "Terug Naar Afvalbakken"
      },
      "dimensions": "Afmetingen:",
      "area": "Oppervlakte:",
      "height": "Hoogte:",
      "moreSpecifications": "Meer Specificaties",
      "materials": "Materialen",
      "qualityMaterials": "Kwaliteitsmaterialen",
      "additionalFeatures": "Extra Kenmerken",
      "features": "Kenmerken",
      "customizationOptions": "Aanpassingsopties",
      "otherModels": "Andere Afvalbak Modellen",
      "otherModelsDescription": "Verken onze selectie afvalbakoplossingen ontworpen voor practicaliteit, duurzaamheid en stijl. Elk model biedt efficiënt afvalbeheer en vult uw eigendom aan.",
      "enquireButton": "Offerte Aanvragen",
      "enquireAbout": "Informeer Over Deze Afvalbak",
      "openGallery": "Galerij Openen",
      "price": "Prijs:"
    },
    "enquiryForm": "Aanvraagformulier",
    "enquiringAbout": "U Informeert Over:",
    "generalEnquiry": "Als u een algemene aanvraag wilt indienen, klik hier."
  }
}
